export default "__VITE_ASSET__Cp5QFJkI__"